import {
    FETCH_CLAIM_HISTORY_REQUEST,
      FETCH_CLAIM_HISTORY_SUCCESS,
      FETCH_CLAIM_HISTORY_FAILURE,
    } from "./FetchClaimHistoryTypes";
    import api from "../../utils/Api";
    
    export const fetchClaimHistoryRequest = () => {
      return {
        type: FETCH_CLAIM_HISTORY_REQUEST,
      };
    };
    
    export const fetchClaimHistorySuccess = (claimHistory) => {
      return {
        type: FETCH_CLAIM_HISTORY_SUCCESS,
        payload: claimHistory,
      };
    };
    
    export const fetchClaimHistoryFailure = (error) => {
      return {
        type: FETCH_CLAIM_HISTORY_FAILURE,
        payload: error,
      };
    };
    
    export const fetchClaimHistory = (invoice_id) => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = `payment/claimhistory/`+invoice_id;
    
      
      return async (dispatch) => {
        dispatch(fetchClaimHistoryRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const claimHistory = response.data.data;
          //console.log("initialNotesData", initialNotesData)
          dispatch(fetchClaimHistorySuccess(claimHistory));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchClaimHistoryFailure(errorMsg));
        }
      };
    };
    